import {Button, Spin} from 'antd';
import {inject, observer} from "mobx-react";
import {toJS} from 'mobx';
import {WeaAlertPage,WeaFormItem, WeaBrowser} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;


@inject("coworkMainStore")
@observer
class Stat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noReadidsShow: false,
      parterShow: false,
      typemanageridsShow: false,
      creatersShow: false,
      principalsShow: false,
      quitersShow: false,
    }
  }
  
  //1 写一个componentDidMount，通过getCoworkDiscussData方法从store取数据
  componentDidMount() {
    const {coworkMainStore} = this.props;
    let stat = toJS(coworkMainStore.stat);
    if (!stat.readed) {
      coworkMainStore.getShareConditionStrList();
    }
  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.coworkId != this.props.coworkId) {
      const {coworkMainStore} = this.props;
      let stat = toJS(coworkMainStore.stat);
      if (!stat.readed) {
        coworkMainStore.getShareConditionStrList();
      }
    }
  }
  
  render() {
    //4 传参
    const {coworkMainStore} = this.props;
    let {stat} = coworkMainStore;
    stat = toJS(stat);
    
    //定义
    const {
      noReadidsShow,
      parterShow,
      typemanageridsShow,
      creatersShow,
      principalsShow,
      quitersShow,
    } = this.state;
    
    if (!stat.readed) {
      return (
        <div style={{height: 300}}><div className="top40 align-center" style={{position: 'relative'}}><Spin /></div></div>
      );
    }
    return (
      ((stat.alist && stat.alist.length !== 0) || (stat.principals && stat.principals.length !== 0) ||
      (stat.creaters && stat.creaters.length !== 0) || (stat.parter && stat.parter.length !== 0) ||
      (stat.typemanagerids && stat.typemanagerids.length !== 0) || (stat.quiters && stat.quiters.length !== 0) ||
      (stat.noReadids && stat.noReadids.length !== 0)) ? (
        <div className="cowork-content-stat cowork-content-style-public">
          <div className="cowork-content-condition">
            {(stat.alist && stat.alist.length !== 0) && (
              <div>
                <p className="cowork-content-pub"><em className="icon-cooperation-condition" style={{color: '#32ADFF'}}/><span>{getLabel(83210, '参与条件')}</span></p>
                <div>
                  {stat.alist.map((item, index) => {
                     let type="17";
                     if(item.type == 1){
                       type = 17;
                      }else if(item.type == 2){
                        type = 194;
                      }else if(item.type == 3){
                        type = 57;
                      }else if(item.type == 4){
                        type = 65;
                      }else if(item.type == 6){
                        type = 278;
                      }
                      return (
                        <WeaFormItem label={item.shareName} labelCol={{span: 6}} wrapperCol={{span: 18}} underline>
                          <span className="wea-field-readonly">                         
                            <span className="ant-col-18">                          
                            <WeaBrowser tabs={item.sharelist} replaceDatas={item.sharelist} viewAttr="1" type={type} isSingle={false} />                           
                            </span>
                            {item.seclevel && <span className="ant-col-6 seclevel">{item.seclevel}-{item.seclevelMax}</span>}
                          </span>
                        </WeaFormItem>
                      )
                    }
                  )}
                </div>
              </div>
            )}
            
            <div>
              <p className="cowork-content-pub"><em className="icon-cooperation-personnel" style={{color: '#6AE072'}}/><span>{getLabel(18605, '参与人员')}</span></p>
              {createUserArray(stat.principals,`${getLabel(344,'主题')}${getLabel(2097,'负责人')}`, principalsShow, this.principalsClick)}
              {createUserArray(stat.creaters,`${getLabel(344,'主题')}${getLabel(382643,'创建人')}`, creatersShow, this.creatersClick)}
              {createUserArray(stat.parterids,getLabel(17689, '参与者'), parterShow, this.parterClick)}
              {createUserArray(stat.typemanagerids,`${getLabel(83209,'版块')}${getLabel(2097,'负责人')}`, typemanageridsShow, this.typemanageridsClick)}
              {createUserArray(stat.quiters,getLabel(382659, '已退出人员'), quitersShow, this.quitersClick)}
            </div>
            
            <div>
              <p className="cowork-content-pub"><em className="icon-cooperation-Not-checked" style={{color: '#FFBB32'}}/><span>{getLabel(17696, '未查看者')}</span></p>
              {createUserArray(stat.noReadids,getLabel(17696, '未查看者'), noReadidsShow, this.noReadidsClick)}
            </div>
          </div>
        </div>) : (
          <div style={{height: window.innerHeight}}>
            <WeaAlertPage icon="icon-coms-blank" paddingTop="40px">
              <div>{getLabel(83553, '暂无数据')}</div>
            </WeaAlertPage>
          </div>
      )
    );
  }
  
  //按钮点击效果
  //版块负责人
  typemanageridsClick = () => {
    this.setState({
      typemanageridsShow: !this.state.typemanageridsShow,
    });
  };
  //主题负责人
  principalsClick = () => {
    this.setState({
      principalsShow: !this.state.principalsShow,
    });
  };
  //主题创建人
  creatersClick = () => {
    this.setState({
      creatersShow: !this.state.creatersShow,
    });
  };
  //未查看者
  noReadidsClick = () => {
    this.setState({
      noReadidsShow: !this.state.noReadidsShow,
    });
  };
  //参与者
  parterClick = () => {
    this.setState({
      parterShow: !this.state.parterShow,
    });
  };
  //已退出人员
  quitersClick = () => {
    this.setState({
      quitersShow: !this.state.quitersShow,
    });
  };
  
}

const createUserArray = (userList, label, show, func) => {
  if (!userList) return undefined;
  let showList = (userList.length <= 5 || show) ? userList : userList.slice(0,5);
  return (
    <WeaFormItem label={label} labelCol={{span: 6}} wrapperCol={{span: 18}} underline>
      <WeaBrowser type="17" isSingle={false} replaceDatas={showList} viewAttr="1"></WeaBrowser>
      {userList.length > 5 && func &&
        <span className="collapse-btn" title={show ? getLabel(26985, '收起') : getLabel(20234, '显示全部')} onClick={func}>
          <em className={show ? "icon-coms-up2" : "icon-coms-down2"}></em>
        </span>
      }
    </WeaFormItem>
  );
};

export default Stat;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cowork/components/cowork/content/Stat.js